import { useRouteTheme } from "../../hooks/useRouteTheme";

const ThemeLoader: React.FC = () => {
  useRouteTheme();

  return null;
};

export default ThemeLoader;
